import { Outlet } from "react-router";
import { Failed, Loading } from "@/components/kit";
import { useProjectContext } from "@/platform/project-context";

// The project's sections live in the sidebar, so this only guards the project read.
export function ProjectLayout() {
  const { project, query } = useProjectContext();
  if (query.error) return <Failed error={query.error} />;
  if (!project) return <Loading />;
  return <Outlet />;
}
